import React, { useEffect, useState } from "react";
import LeadershipBoard from "../../components/Leadership/LeadershipBoard";
import { EmptyState, useAgencyInfo } from "./common";
import { collection, db, onSnapshot } from "../boardData";

// The legacy board's leadership screen, in a Studio widget: same four themes,
// same rank ordering and saved rows (see components/Leadership). Officers come
// from the widget itself (arranged in the Board Designer) or, with
// `source: "legacy"`, from the agency's Legacy Single Board list and theme so
// they are kept in one place.
function useLegacyLeadership(agency, enabled) {
  const [state, setState] = useState({ leadership: [], theme: null, loaded: false });
  useEffect(() => {
    if (!enabled || !agency) return undefined;
    return onSnapshot(
      collection(db, `${agency} Station Board`),
      (snap) => {
        const d = snap.docs.map((x) => x.data()).find((x) => Array.isArray(x.leadership)) || {};
        setState({ leadership: d.leadership || [], theme: d.leadershipTheme || null, loaded: true });
      },
      () => setState({ leadership: [], theme: null, loaded: true })
    );
  }, [agency, enabled]);
  return state;
}

const LeadershipWidget = ({ config = {}, agency }) => {
  const fromLegacy = config.source === "legacy";
  const legacy = useLegacyLeadership(agency, fromLegacy);
  const info = useAgencyInfo(agency);

  const leadership = fromLegacy ? legacy.leadership : config.leadership || [];
  const theme = (fromLegacy ? legacy.theme : null) || config.theme || "classicRed";

  if (leadership.length === 0 && (!fromLegacy || legacy.loaded)) {
    return (
      <div className="sb-card sb-leadership">
        <EmptyState
          icon="★"
          label={fromLegacy ? "No officers in the Legacy Single Board list yet." : "Add officers in the Board Designer."}
        />
      </div>
    );
  }

  return (
    <div className="sb-leadership-legacy">
      <LeadershipBoard
        leadership={leadership}
        theme={theme}
        agencyLogo={info.logo}
        agencyName={info.name || agency}
        agencyDescription={info.description}
        logoAlt={info.name}
      />
    </div>
  );
};

export default LeadershipWidget;
